export default [
    {
        path: "transaction-report",
        name: "onlinetransactionreport",
        component: () =>
            import(
                /* webpackChunkName: "OnlineTransactionReport" */ "../pages/onlineTransactionReport/OnlineTransactionReport.vue"
            ),
        meta: {
            title: `Online Transaction Report`,
        },
    }
];
